import React from 'react';
import { Button } from 'reactstrap';
import {
  Link,
  withRouter,
  RouteComponentProps,
  matchPath,
  generatePath,
} from 'react-router-dom';

const InterviewButton = (
  props: RouteComponentProps<{ organizationId: string }>,
) => {
  const match = matchPath<{ organizationId: string; patientId: string }>(
    props.location.pathname,
    {
      path: '/organization/:organizationId/patient/:patientId',
    },
  );
  const gPath = match
    ? generatePath(
        '/organization/:organizationId/patient/:patientId/interview',
        match.params,
      )
    : null;
  return (
    <Button
      tag={Link}
      block
      color="success"
      className="text-center"
      to={gPath}
      disabled={!gPath}>
      Interview
    </Button>
  );
};

export default withRouter(InterviewButton);
